import auth from '@/router/auth'
import PromotionIndex from '@/components/class-users/Index'
import PromotionCreate from '@/components/class-users/Create'
import PromotionUpdate from '@/components/class-users/Update'
import PromotionShow from '@/components/class-users/Show'

export default [
  {
    path: '/class-users',
    name: 'class-users-index',
    component: PromotionIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/class-users/create',
    name: 'class-users-create',
    component: PromotionCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/class-users/update/:id',
    name: 'class-users-update',
    component: PromotionUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/class-users/show/:id',
    name: 'class-users-show',
    component: PromotionShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/class-users/router.js